import {
  initialState,
  Actions,
  State,
  EDIT_POST,
  EDIT_POST_SUCCESS,
  EDIT_POST_ERROR,
  RESET_EDIT_POST,
} from "../../types/post/edit-post";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_POST:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EDIT_POST_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EDIT_POST_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EDIT_POST:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
